<template>
  <div class="ai-setting">
    <p>{{ $t('lang.k_159001') }}</p>
    <div class="ai-setting__ft">
      <vh-button type="primary" size="medium" round class="ai-setting-btn" @click="goPage">
        {{ $t('lang.k_159002') }}
      </vh-button>
    </div>
  </div>
</template>
<script>
  import { sessionOrLocal } from '@/utils/utils';
  export default {
    methods: {
      goPage() {
        try {
          const liveDetailInfo = JSON.parse(sessionOrLocal.get('liveDetailInfo'));
          const { href } = this.$router.resolve({ path: `/live/edit/${liveDetailInfo.id}` });
          window.open(href, '_blank');
        } catch (ex) {}
      }
    }
  };
</script>
<style lang="less">
  .ai-setting {
    padding: 1px 0;
    box-sizing: border-box;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #262626;
    line-height: 22px;

    &__ft {
      margin-top: 24px;
      width: 100%;
      text-align: center;
    }
    .ai-setting-btn {
      min-width: 104px;
    }
  }
</style>
